import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ICurriculum,
  ICurriculumForHome,
  ISearchOption,
  ISubjectMapDataForSubjectCode,
} from '.';
import { ApiPaths, APIDataProvider, TApiResponse } from '../../api';

export interface IGetSubjectMapDataBySubjectCode {
  subjectCode: string;
}

const apiDataProvider = new APIDataProvider();

export const getCurriculums = createAsyncThunk('curriculum/list', async () => {
  const response = await apiDataProvider.get<TApiResponse<Array<ICurriculum>>>(
    `${ApiPaths.curriculums}/quiztopiya`
  );

  return response.data;
});

export const getCurriculumsForHomePage = createAsyncThunk(
  'curriculum/getCurriculumsForHomePage',
  async () => {
    const response = await apiDataProvider.get<
      TApiResponse<Array<ICurriculumForHome>>
    >(`${ApiPaths.curriculums}/getCurriculumsForHomePage`);

    return response.data;
  }
);

export const getSubjectMapDataBySubjectCode = createAsyncThunk(
  'curriculum/subjectMapData',
  async (data: IGetSubjectMapDataBySubjectCode) => {
    const response = await apiDataProvider.post<
      TApiResponse<ISubjectMapDataForSubjectCode>
    >(`${ApiPaths.curriculums}/subjectMapDataForSubjectCode`, data);

    return response.data;
  }
);

export const getSearchOptionsForHomePage = createAsyncThunk(
  'curriculum/getSearchOptionsForHomePage',
  async () => {
    const response = await apiDataProvider.get<
      TApiResponse<Array<ISearchOption>>
    >(`${ApiPaths.curriculums}/getSearchOptionsForHomePage`);

    return response.data;
  }
);

export default getCurriculums;
